import { createSSRApp, createApp, h } from "vue";
import isServer from "@/_base/isServer";
import App from "./App.vue";
import createRouter from "./router";
import * as nativeStore from "./store/useNativeStore";
import * as vuexStore from "./store/useVuexStore";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";


import Swal from "./plugin/swal.js";
import ValidationForm from "./plugin/validation.js";
import $axios from "@/api/http";
import VueLazyload from "@jambonn/vue-lazyload";
import moment from "moment";
import { createHead } from "@vueuse/head";
import { createGtm } from "@gtm-support/vue-gtm";

export default function (args) {
	const rootComponent = {
		render: () => h(App),
		components: {
			App,
		},
		setup(props) {
			nativeStore.provideStore(args.nativeStore);
			vuexStore.provideStore(args.vuexStore);
		}
	}

	const app = (isServer ? createSSRApp : createApp)(rootComponent);
	app.config.globalProperties.isServer = isServer;

	const router = createRouter(args.vuexStore, app);

	app.use(args.vuexStore);
	app.use(router);

	
	app.use(Swal, {
		reverseButtons: true,
		confirmButtonText: "確定",
		cancelButtonText: "取消",
		confirmButtonColor: "#19322f",
		cancelButtonColor: "#666666",
	});
	app.use(ValidationForm);
	app.use($axios);
	app.use(VueLazyload, {
		loading: require("./assets/images/common/transparent_350x350.png"),
		error: require("./assets/images/common/transparent_350x350.png"),
	});
	app.config.globalProperties.$filters = {
		currency: (amount) => {
			return typeof amount === "number" ? amount.toLocaleString() : Number(amount).toLocaleString();
		},
		notNumberString: (string) => {
			return isNaN(Number(string));
		},
		carbon: (mass) => {
			return mass >= 1000 ? `${(Math.round(mass) / 1000).toFixed(2)}kg` : `${mass}g`;
		},
		date: (dateString, format = "yyyy/MM/DD") => {
			return dateString ? moment(dateString).format(format) : "";
		},
		inCoolingOffPeriod: (deliveredDate) => {
			// 計算「七天鑑賞期」:
			// 根據消費者保護法之規定，享有商品到貨的七日鑑賞期權益，是由消費者完成簽收取件的隔日開始算起至第7天止（如您的收件地址有管理員代收，則以代收的隔日起算喔，請留意送件通知），為七日鑑賞期限。
			// 例如，完成簽收的時間是12/20，其七天鑑賞期起訖日即為12/21~12/27。
			return moment().isBefore(moment(deliveredDate).endOf("day").add(7, "days"));
		},
		isSameDomain: (link) => {
			return isServer ? false : link.startsWith(location.origin);
		},
		htmlAnchorToRouter: (htmlString) => {
			return typeof htmlString === "string" || htmlString instanceof String ? htmlString.replace(/<a (.*?)href="(?!(http:\/\/|https:\/\/))(.*?)"(.*?)target="_self"(.*?)>/g, `<a $1href="$3" onclick="event.preventDefault(); app.__vue_app__.config.globalProperties.$router.push('$3')"$4>`) : undefined;
		},
	}

	const head = createHead();
	app.use(head);
	app.use(createGtm({
		id: process.env.VUE_APP_GTM_ID,
		defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
		compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
		// nonce: "2726c7f26c", // Will add `nonce` to the script tag
		enabled: JSON.parse(process.env.VUE_APP_GTM_ENABLED), // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
		debug: JSON.parse(process.env.VUE_APP_GTM_DEBUG), // Whether or not display console logs debugs (optional)
		loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
		vueRouter: router, // Pass the router instance to automatically sync with router (optional)
		//ignoredViews: ["MemberInfo", "OrderDetail", "OrderReturn", "PasswordModify", "PasswordForgot", "PasswordReset"], // Don't trigger events for specified router names (optional)
		trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
	}));
	return {
		app,
		router,
		head,
	};
}
